import styled from 'styled-components';

const purple = (props) => props.theme.palette.purple.main;

// Destaque da PMT: o roxo da paleta, puxando para o magenta do gradiente.
export const PmtBanner = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 16px;
  padding: 10px 16px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(90deg, ${purple} 0%, #ae4a96 100%);
`;

export const PmtIcon = styled.div.attrs({})`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
`;

export const PmtText = styled.div.attrs({})`
  min-width: 0;
`;

export const PmtLabel = styled.span.attrs({})`
  display: block;
  font-size: 15px;
  font-weight: 600;
`;

export const PmtSubtitle = styled.span.attrs({})`
  display: block;
  font-size: 12px;
  opacity: 0.85;
`;

export const PmtValue = styled.span.attrs({})`
  margin-left: auto;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  font-size: 24px;
  font-weight: 700;
  white-space: nowrap;
`;

// Quatro colunas para o resumo caber sem empurrar o modal para a rolagem;
// em tela estreita vira duas.
export const SummaryGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 0 16px 16px;
  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const SummaryItem = styled.div.attrs({})`
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #ece8f7;
  border-radius: 10px;
  background: #fff;
`;

export const ItemLabel = styled.span.attrs({})`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #718096;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .material-symbols-outlined {
    color: ${purple};
  }
`;

export const ItemValue = styled.span.attrs({})`
  display: block;
  margin-top: 2px;
  font-size: 15px;
  font-weight: 700;
  color: #1f1b2e;
  white-space: nowrap;
`;
